import MainLayout from "layout/main-layout";
import PrivateOutlet from "./private-outlet";
import React from "react";
import {Outlet, Navigate} from "react-router-dom";
import Receive from "pages/Receive/Receive";
import SSOlogin from "pages/LoginSso/SSOlogin";
import Examination from "pages/Examination/Examination";
import Refractive from "pages/Refractive/Refractive";
import Analysis from "pages/Analysis/Analysis";
import NurseOut from "pages/NurseOut/NurseOut";
import Sample from "pages/SamplePage/Sample";
import PharmacyStore from "pages/Medicines/PharmacyStore/PharmacyStore";
import MedicineStore from "pages/Medicines/MedicineStore/MedicineStore";
import Pay from "pages/Pay/Pay";
import GlassKiosk from "pages/Glass/GlassKiosk/GlassKiosk";
import RoleOutlet from "./role-outlet";
import GlassStoreHouse from "pages/Glass/GlassStoreHouse/GlassStoreHouse";
import Surgery from "pages/ResidentialNurse/Surgery/Surgery";
import Authorization from "pages/Authorization/Authorization";
import Login from "pages/Login/Login";
import CommonCatalog from "pages/CommonCatalog/CommonCatalog";
import Diagnose from "pages/Diagnose/Diagnose";
import ConsultantAndTreatment from "pages/CustomerService/ConsultantAndTreament/ConsultantAndTreatment";
import CustomerCare from "pages/Customer/CustomerCare/CustomerCare";
import ServiceAndOffer from "pages/Customer/ServiceAndOffer/ServiceAndOffer";
import MedicalSuppliesStore from "pages/Medicines/MedicalSuppliesStore/MedicalSuppliesStore";
import Nursing from "pages/ResidentialNurse/Nursing/Nursing";
import Treatment from "pages/ResidentialNurse/Treatment/Treatment";
// import Electrocardiography from "pages/Diagnose copy/Electrocardiography";
import PushDataXML from "pages/Pay/PushDataXML/PushDataXML";
import RenderXML from "pages/XML/RenderXML/RenderXML";
import Electrocardiography from "pages/Electrocardiography/Electrocardiography";

import EmployeeDirectory from "../pages/AdministrativePersonnel/HumanResourcesManagement/EmployeeDirectory/EmployeeDirectory";
import Bonus from "../pages/AdministrativePersonnel/HumanResourcesManagement/Bonus/Bonus";
import Discipline from "../pages/AdministrativePersonnel/HumanResourcesManagement/Discipline/Discipline";
import StandardWorkMonth from "../pages/AdministrativePersonnel/HumanResourcesManagement/StandardWorkMonth/StandardWorkMonth";
import Training from "../pages/AdministrativePersonnel/HumanResourcesManagement/Training/Training";
import CandidateDirectory from "../pages/AdministrativePersonnel/HumanResourcesManagement/CandidateDirectory/CandidateDirectory";
import Recruitment from "../pages/AdministrativePersonnel/HumanResourcesManagement/Recruitment/Recruitment";
import Overtime from "../pages/AdministrativePersonnel/SalaryManagement/Overtime/Overtime";
import CompensatoryLeave from "../pages/AdministrativePersonnel/SalaryManagement/CompensatoryLeave/CompensatoryLeave";
import Late from "../pages/AdministrativePersonnel/SalaryManagement/Late/Late";
import Payroll from "../pages/AdministrativePersonnel/SalaryManagement/Payroll/Payroll";
import MonitorBHXH from "../pages/AdministrativePersonnel/SalaryManagement/MonitorBHXH/MonitorBHXH";
import SalarySettings from "../pages/AdministrativePersonnel/SalaryManagement/SalarySettings/SalarySettings";
import CardAndOffer from "pages/Customer/CardAndOffer/CardAndOffer";
import Timekeeping from "../pages/AdministrativePersonnel/SalaryManagement/Timekeeping/Timekeeping";
import TechnicalService from "../pages/ServiceManagement/TechnicalService/TechnicalService";
import ServicePackage from "pages/ServiceManagement/ServicePackage/ServicePackage";
import TNCN from "../pages/AdministrativePersonnel/SalaryManagement/ TaxTableTNCN/TNCN";
import RevenuesReport from "pages/AccoutingFinancial/RevenuesReport/RevenuesReport";
import Shift from "../pages/AdministrativePersonnel/SalaryManagement/Shift/Shift";
import StoreReport from "pages/AccoutingFinancial/StoreReport/StoreReport";
import RoughTimekeeping from "pages/AdministrativePersonnel/SalaryManagement/RoughTimekeeping/RoughTimekeeping";
import DocumentManagement from "pages/AdministrativePersonnel/HumanResourcesManagement/DocumentManagement/DocumentManagement";
import CombineReport from "pages/AccoutingFinancial/CombineReport/CombineReport";
import ApprovePayroll from "pages/AdministrativePersonnel/SalaryManagement/ApprovePayroll";
import ApprovePermission from "pages/AdministrativePersonnel/SalaryManagement/ApprovePermission";
import ApproveStatus from "pages/AdministrativePersonnel/SalaryManagement/ApproveStatus";
import ApprovePersons from "pages/AdministrativePersonnel/SalaryManagement/ApprovePersons";
import RegisterForLeave from "pages/AdministrativePersonnel/SalaryManagement/RegisterForLeave/RegisterForLeave";
import SearchPatient from "pages/SearchPatient/SearchPatient";
import SignSecure from "pages/SignSecure/SignSecure";
import ProposeShopping from "pages/Shopping/ProposeShopping/ProposeShopping";
import ProposePay from "pages/Shopping/ProposePay/ProposePay";

let MainRoutes = [
  {path: "", element: <Navigate to="/tiep-nhan" replace />},
  {
    path: "/login",
    element: <Login></Login>,
  },
  {
    path: "/logout",
    element: <Login></Login>,
  },
  {
    path: "",
    element: <PrivateOutlet></PrivateOutlet>,
    children: [
      {
        path: "",
        element: <MainLayout />,
        children: [
          {
            path: "/kham-benh",
            element: <RoleOutlet roles={["admin"]} component={Outlet} />,
            children: [
              {
                path: "/kham-benh",
                element: (
                  <RoleOutlet roles={["admin"]} component={Examination} />
                ),
              },
            ],
          },
          {
            path: "/tiep-nhan",
            element: <Receive />,
          },

          {
            path: "/khuc-xa",
            element: <Refractive />,
          },
          {
            path: "/dieu-duong",
            element: <Outlet />,
            children: [
              {
                path: "/dieu-duong/ngoai-tru",
                element: <NurseOut></NurseOut>,
              },
            ],
          },
          {
            path: "/dieu-tri-noi-tru",
            element: <Outlet />,
            children: [
              {
                path: "/dieu-tri-noi-tru/dieu-duong-noi-tru",
                element: <Nursing />,
              },
              {
                path: "/dieu-tri-noi-tru/dieu-tri",
                element: <Treatment />,
              },
              {
                path: "/dieu-tri-noi-tru/phau-thuat",
                element: <Surgery />,
              },
            ],
          },
          {
            path: "/xet-nghiem",
            element: <Analysis />,
          },
          {
            path: "/chan-doan-hinh-anh",
            element: <Diagnose />,
          },
          {
            path: "/dien-tim",
            element: <Electrocardiography />,
          },
          {
            path: "/phau-thuat",
            element: <Surgery />,
          },
          {
            path: "/thanh-toan",
            element: <Outlet />,
            children: [
              {
                path: "/thanh-toan/thanh-toan",
                element: <Pay></Pay>,
              },
              {
                path: "/thanh-toan/day-du-lieu-xml",
                element: <PushDataXML />,
              },
              {
                path: "/thanh-toan/ket-xuat-xml",
                element: <RenderXML />,
              },
            ],
          },
          {
            path: "/duoc-vat-tu",
            element: <Outlet />,
            children: [
              {
                path: "/duoc-vat-tu/nha-thuoc",
                element: <MedicineStore></MedicineStore>,
              },
              {
                path: "/duoc-vat-tu/kho-duoc",
                element: <PharmacyStore />,
              },
              {
                path: "/duoc-vat-tu/kho-vat-tu-y-te",
                element: <MedicalSuppliesStore />,
              },
            ],
          },
          {
            path: "/cs-khach-hang",
            element: <Outlet />,
            children: [
              {
                path: "/cs-khach-hang/tu-van-dieu-tri",
                element: <ConsultantAndTreatment />,
              },
              {
                path: "/cs-khach-hang/cham-soc-khach-hang",
                element: <CustomerCare />,
              },
              {
                path: "/cs-khach-hang/goi-dich-vu-va-chuong-trinh-uu-dai",
                element: <ServiceAndOffer />,
              },
              {
                path: "/cs-khach-hang/the-kham-va-chuong-trinh-uu-dai",
                element: <CardAndOffer />,
              },
            ],
          },
          {
            path: "/quan-ly-dich-vu",
            element: <Outlet />,
            children: [
              {
                path: "/quan-ly-dich-vu/dich-vu-ky-thuat",
                element: <TechnicalService />,
              },
              {
                path: "/quan-ly-dich-vu/goi-dich-vu",
                element: <ServicePackage />,
              },
            ],
          },
          {
            path: "/kinh",
            element: <Outlet />,
            children: [
              {
                path: "/kinh/quay-kinh",
                element: <GlassKiosk />,
              },
              {
                path: "/kinh/kho-kinh",
                element: <GlassStoreHouse />,
              },
            ],
          },
          {
            path: "/quan-ly-nhan-su",
            element: <Outlet />,
            children: [
              {
                path: "/quan-ly-nhan-su/danh-sach-nhan-vien",
                element: <EmployeeDirectory />,
              },
              // {
              //   path: "/quan-ly-nhan-su/khen-thuong",
              //   element: <Bonus />,
              // },
              {
                path: "/quan-ly-nhan-su/ky-luat",
                element: <Discipline />,
              },
              {
                path: "/quan-ly-nhan-su/cong-chuan-thang",
                element: <StandardWorkMonth />,
              },
              {
                path: "/quan-ly-nhan-su/dot-tuyen-dung",
                element: <Recruitment />,
              },
              {
                path: "/quan-ly-nhan-su/danh-muc-ung-vien",
                element: <CandidateDirectory />,
              },
              {
                path: "/quan-ly-nhan-su/khoa-dao-tao",
                element: <Training />,
              },
            ],
          },
          {
            path: "/tinh-luong",
            element: <Outlet />,
            children: [
              {
                path: "/tinh-luong/cham-cong",
                element: <Timekeeping />,
              },
              {
                path: "/tinh-luong/cham-cong-tho",
                element: <RoughTimekeeping />,
              },
              {
                path: "/tinh-luong/theo-doi-nghi-bu",
                element: <CompensatoryLeave />,
              },
              {
                path: "/tinh-luong/theo-doi-di-muon",
                element: <Late />,
              },
              {
                path: "/tinh-luong/dang-ky-nghi-phep",
                element: <RegisterForLeave />,
              },
              {
                path: "/tinh-luong/cham-cong-lam-them-gio",
                element: <Overtime />,
              },
              {
                path: "/tinh-luong/bang-luong",
                element: <Payroll />,
              },
              {
                path: "/tinh-luong/theo-doi-bhxh",
                element: <MonitorBHXH />,
              },
              {
                path: "/tinh-luong/cai-dat-luong",
                element: <SalarySettings />,
              },
              {
                path: "/tinh-luong/bieu-thue",
                element: <TNCN />,
              },
              {
                path: "/tinh-luong/ca-lam-viec",
                element: <Shift />,
              },
              {
                path: "/tinh-luong/duyet-bang-luong",
                element: <ApprovePayroll />,
              },
              {
                path: "/tinh-luong/khai-bao-quyen-duyet",
                element: <ApprovePermission />,
              },
              {
                path: "/tinh-luong/danh-muc-trang-thai-duyet",
                element: <ApproveStatus />,
              },
              {
                path: "/tinh-luong/khai-bao-nguoi-duyet",
                element: <ApprovePersons />,
              },
            ],
          },
          {
            path: "/quan-ly-van-ban",
            element: <DocumentManagement />,
          },
          {
            path: "/tai-chinh-ke-toan",
            element: <Outlet />,
            children: [
              {
                path: "/tai-chinh-ke-toan/bao-cao-doanh-thu",
                element: <RevenuesReport />,
              },
              {
                path: "/tai-chinh-ke-toan/bao-cao-kho",
                element: <StoreReport />,
              },
              {
                path: "/tai-chinh-ke-toan/bao-cao-tong-hop",
                element: <CombineReport />,
              },
            ],
          },
          {
            path: "/benh-nhan-cu",
            element: <SearchPatient />,
          },
          {
            path: "/quan-ly-mua-sam",
            element: <Outlet />,
            children: [
              {
                path: "/quan-ly-mua-sam/mua-sam",
                element: <ProposeShopping />,
              },
              {
                path: "/quan-ly-mua-sam/thanh-toan",
                element: <ProposePay />,
              },
            ],
          },
          {
            path: "/he-thong",
            element: <Outlet />,
            children: [
              {
                path: "/he-thong/phan-quyen",
                element: <Authorization />,
              },
              {
                path: "/he-thong/danh-muc-chung",
                element: <CommonCatalog />,
              },
            ],
          },
          {
            path: "/trang-mau",
            element: <Sample />,
          },
          {
            path: "/ki-bao-mat",
            element: <SignSecure />,
          },
        ],
      },
    ],
  },
];

export default MainRoutes;
